import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div>
            <h3 className="font-serif text-lg font-bold mb-4">おかやま英会話教室株式会社</h3>
            <ul className="space-y-3">
              <li className="text-gray-300 text-sm">
                <i className="ri-map-pin-line mr-2"></i>
                〒700-0000 岡山県岡山市北区表町1-2-3
              </li>
              <li className="text-gray-300 text-sm">
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </li>
              <li className="text-gray-300 text-sm">
                <i className="ri-printer-line mr-2"></i>
                086-012-3457
              </li>
              <li className="text-gray-300 text-sm">
                <i className="ri-time-line mr-2"></i>
                9:00 - 18:00
              </li>
              <li className="text-gray-300 text-sm">定休日: 日曜日・祝日</li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg font-bold mb-4">メニュー</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm">
                  TOP
                </Link>
              </li>
              <li>
                <Link to="/service" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Service
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/teacher" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Teacher Profile
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg font-bold mb-4">フォローする</h3>
            <div className="flex space-x-4 mb-6">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-mint-500 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-mint-500 transition-colors cursor-pointer"
                aria-label="LINE"
              >
                <i className="ri-line-fill text-xl"></i>
              </a>
            </div>
            <p className="text-gray-300 text-sm">
              最新情報をお届けします
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 おかやま英会話教室株式会社 All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};